import { useContext } from 'react';
import {
  AppToastContext,
  AppToastContextValue,
} from '@components/AppToastProvider';

function useAppToastContext(): AppToastContextValue {
  return useContext(AppToastContext);
}

export default useAppToastContext;
